// @vendors
const Immutable = require('immutable');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const initialState = Immutable.fromJS({
    isFetching: false,
    submitSuccessFull: false,
    error: false,
    updatedStrategyName: '',
});

const RADissociateObjective = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_DISSOCIATE_OBJECTIVE_REQUEST:
            return state.merge({
                isFetching: true,
                error: false,
            });
        case actionTypes.RA_DISSOCIATE_OBJECTIVE_FAILURE:
            return state.merge({
                isFetching: false,
                error: true,
            });
        case actionTypes.RA_DISSOCIATE_OBJECTIVE_SUCCESS:
            const { displayName } = action.payload.data;
            return state.merge({
                isFetching: false,
                submitSuccessFull: true,
                error: false,
                updatedStrategyName: displayName,
            });
        case actionTypes.RA_DISSOCIATE_OBJECTIVE_RESET:
            return initialState;
        default:
            return state;
    }
};

module.exports = RADissociateObjective;
